import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tag } from '@guildeducationinc/recess';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { Tooltip } from '@mui/material';
import { getLocalDate, useLocale } from 'pe-core-frontend';
export const RuleExceptionStatusTag = ({ startsOn, expiresOn, comment, }) => {
    const { t } = useLocale();
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    // Return null if dates are not provided
    if (!startsOn || !expiresOn) {
        return null;
    }
    // Determine status and color based on date range
    let statusText = '';
    let statusColor = 'green';
    if (today < getLocalDate(startsOn)) {
        statusText = t('Upcoming');
        statusColor = 'yellow';
    }
    else if (today > getLocalDate(expiresOn)) {
        statusText = t('Expired');
        statusColor = 'red';
    }
    else {
        statusText = t('Active');
        statusColor = 'green';
    }
    return (_jsxs("div", { className: 'flex flexItems--center mb-1 gap-1', children: [_jsx(Tag, { appearance: 'quiet', color: statusColor, children: t('Exception: Valid from {startsOn} to {expiresOn}', {
                    values: {
                        startsOn,
                        expiresOn,
                    },
                }) }), _jsx(Tag, { appearance: 'quiet', color: statusColor, children: statusText }), comment && (_jsx(Tooltip, { title: comment, placement: 'right', children: _jsx("span", { children: _jsx(InfoOutlinedIcon, { size: 20 }) }) }))] }));
};
